import { ReactNode } from 'react';
import { Box, Container, Toolbar } from '@mui/material';
import { Header } from './Header';

interface MainLayoutProps {
  children: ReactNode;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false;
}

export function MainLayout({ children, maxWidth = 'lg' }: MainLayoutProps) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Header />
      <Toolbar /> {/* Spacer for fixed AppBar */}
      <Container 
        component="main" 
        maxWidth={maxWidth}
        sx={{ 
          flex: 1, 
          py: 3,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {children}
      </Container>
    </Box>
  );
}
